import { common } from "./common";
import { nav } from "./nav";
import { validation } from "./validation";
import { trips } from "./trips";
import { planning } from "./planning";
import { orders } from "./orders";
import { crm } from "./crm";
import { ops } from "./ops";
import { opsAdmin } from "./opsAdmin";
import { finance } from "./finance";
import { catalog } from "./catalog";
import { content } from "./content";
import { media } from "./media";
import { mediaViewer } from "./mediaViewer";
import { mediaBulk } from "./mediaBulk";
import { mediaUpload } from "./mediaUpload";
import { mediaPicker } from "./mediaPicker";
import { people } from "./people";
import { guideProfile } from "./guideProfile";
import { newsletter } from "./newsletter";
import { marketing } from "./marketing";
import { system } from "./system";
import { settings } from "./settings";
import { shared } from "./shared";
import { apiErrors } from "./apiErrors";
import { webHints } from "./webHints";

// Assembled English dictionary — one file per admin area so parallel work never
// collides. The cs/ mirror is type-checked against this shape (cs: typeof en),
// so a key added here without its Czech twin fails `pnpm typecheck`.
export const en = {
  translation: {
    common,
    nav,
    validation,
    trips,
    planning,
    orders,
    crm,
    ops,
    opsAdmin,
    finance,
    catalog,
    content,
    media,
    mediaViewer,
    mediaBulk,
    mediaUpload,
    mediaPicker,
    people,
    guideProfile,
    newsletter,
    marketing,
    system,
    settings,
    shared,
    apiErrors,
    webHints,
  },
};

export type Resources = typeof en;
